import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getCreditBalances,
  listCreditLedger,
  topUpCredits,
  type TopUpCreditsInput,
} from '@/lib/credits'
import type { NotificationChannel } from '@riverpark/types'

const BALANCE_KEY = ['credits', 'balance']

export function useCreditBalances() {
  return useQuery({ queryKey: BALANCE_KEY, queryFn: getCreditBalances })
}

export function useCreditLedger(channel: NotificationChannel) {
  return useQuery({
    queryKey: ['credits', 'ledger', channel],
    queryFn: () => listCreditLedger(channel),
  })
}

export function useTopUpCredits() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: TopUpCreditsInput) => topUpCredits(input),
    onSuccess: (_data, variables) => {
      void qc.invalidateQueries({ queryKey: BALANCE_KEY })
      void qc.invalidateQueries({ queryKey: ['credits', 'ledger', variables.channel] })
    },
  })
}
